/**
 * Convert a `git config --get remote.origin.url` value to a clickable web URL.
 * Accepts the four forms `normalizeOriginToSlug` ingests:
 *   - `https://host/owner/name(.git)?`             → `https://host/owner/name`
 *   - `git@host:owner/name(.git)?` (SCP)           → `https://host/owner/name`
 *   - `ssh://git@host/owner/name(.git)?`           → `https://host/owner/name`
 *   - `ssh://git@host:port/owner/name(.git)?`      → `https://host/owner/name`
 *     (e.g. github's `ssh.github.com:443` workaround for restricted networks;
 *     the port is dropped because the web URL is always plain https/443)
 *
 * Protocol-form must run before SCP because the SCP regex would otherwise eat
 * `:port` as part of the path (`ssh://git@host:443/x` → `https://host/443/x`,
 * a 404). Falls back to the input with `.git` stripped so an unrecognised
 * origin still renders something rather than a literal `git@…` href the
 * browser can't open.
 */
export function originToWebUrl(origin: string): string {
  const stripped = origin.trim().replace(/\.git$/, "");

  const proto = stripped.match(
    /^(?:ssh|git):\/\/(?:[^@/]+@)?([^/:]+)(?::\d+)?\/(.+)$/,
  );
  if (proto) {
    const [, host, path] = proto;
    return `https://${host}/${path}`;
  }

  const scp = stripped.match(/^[^@\s]+@([^:\s]+):(.+)$/);
  if (scp) {
    const [, host, path] = scp;
    return `https://${host}/${path}`;
  }

  return stripped;
}
